import { CountryRegion, ResidenceCountry } from '@lx/shared/data-access/destination';
import { Country, CourseType } from '@lx/shared/data-access/types';
import {
  AccommodationExtra,
  CourseSelectionDto,
  InsuranceExtra,
  PremiumActivitiesSelection,
  PremiumResidenceExtra,
  PrivateLessonsExtra,
  QuoteCamp,
  QuoteDiscounts,
  QuoteOnlineSchool,
  QuoteSchool,
  SchoolPackageDto,
  StudentDetails,
  TransferExtra,
} from '@lx/quote-tool/shared/types';
import { PremiumActivity } from '@lx/shared/data-access/school';
import { SchoolSupplement, Transfer } from '@lx/shared/data-access/products';
import { LimitedCurrencyAmount } from '@lx/currency/shared/model/currency.model';

export interface QuoteToolSlot {
  key: number;
  premiumResidencesAvailable?: boolean;
  language?: string;
  programType?: string;
  country?: string;
  school?: string;
  duration?: number;
  startDate?: string; //dd/mm/YYYY
  endDate?: string; //dd/mm/YYYY
  course?: string;
  courseType?: string;
  timezone?: string;
  startTime?: string;
  endTime?: string;
  accommodation?: AccommodationExtra;
  insurance?: InsuranceExtra;
  transfer?: TransferExtra;
  premiumActivities?: PremiumActivitiesSelection[];
  premiumResidence?: PremiumResidenceExtra;
  privateLessons?: PrivateLessonsExtra;
  discounts?: QuoteDiscounts[];
  discountTotal?: LimitedCurrencyAmount[];
  destinationCurrency?: string;
  displayCurrency?: string;
  grandTotal?: LimitedCurrencyAmount[];
  productTotal?: LimitedCurrencyAmount[];
}
export interface OptOutProduct {
  optOutProductCode: string;
  optOutProductInfo: string;
}

export interface QuoteToolState {
  slots: QuoteToolSlot[];
  studentDetails?: StudentDetails;
  selectedCountryOfResidence?: string;
  selectedRegionOfResidence?: string;
  countriesOfResidence?: ResidenceCountry[];
  regionsOfResidence?: CountryRegion[];
  destinationCountries?: Country[];
  dataLayerDestinationCountries?: Country[];
  camps?: QuoteCamp[];
  packages?: SchoolPackageDto[];
  schools?: QuoteSchool[];
  courses?: CourseSelectionDto[];
  courseTypes?: CourseType[];
  premiumActivities?: PremiumActivity[];
  transfers?: Transfer[];
  schoolSupplements?: SchoolSupplement[];
  onlineSchoolCode?: QuoteOnlineSchool;
  optOutProduct?: OptOutProduct;
}

export const defaultQuoteToolState: QuoteToolState = {
  slots: [{ key: 1 }],
};
